import { Box, Button, Flex, P, Small, TextArea } from "orcs-design-system";

export const EXCEPTION_REASON_MODAL_TITLE =
  "Why should this requisition proceed?";
export const EXCEPTION_REASON_MODAL_BODY =
  "Guardrails flagged warnings on this requisition. Explain why it should still go ahead. Approvers will see your reason before they decide.";
export const EXCEPTION_REASON_FIELD = "Exception reason";
export const EXCEPTION_REASON_SAVE = "Save exception reason";

type ExceptionReasonLayout = "footer" | "modal";

const ExceptionReasonForm = ({
  layout,
  draft,
  saving,
  error,
  fieldId,
  onChange,
  onSave,
  onCancel,
}: {
  layout: ExceptionReasonLayout;
  draft: string;
  saving: boolean;
  error: string | null;
  fieldId: string;
  onChange: (value: string) => void;
  onSave: (reason: string) => void;
  onCancel?: () => void;
}) => {
  const field = (
    <TextArea
      id={fieldId}
      label={EXCEPTION_REASON_FIELD}
      fullWidth
      rows="4"
      value={draft}
      onChange={(event) => onChange(event.target.value)}
    />
  );
  const errorLine = error ? (
    <P mb="s" color="danger">
      {error}
    </P>
  ) : null;
  const saveDisabled = saving || draft.trim() === "";
  switch (layout) {
    case "footer":
      return (
        <Flex flexDirection="column" gap="xs" width="100%">
          <Small uppercase weight="bold" color="greyDark">
            {EXCEPTION_REASON_FIELD}
          </Small>
          <Small color="greyDark">{EXCEPTION_REASON_MODAL_BODY}</Small>
          {errorLine}
          {field}
          <Box>
            <Button
              type="button"
              disabled={saveDisabled}
              onClick={() => onSave(draft)}
            >
              {EXCEPTION_REASON_SAVE}
            </Button>
          </Box>
        </Flex>
      );
    case "modal":
      return (
        <>
          <P fontSize="1" mb="s">
            {EXCEPTION_REASON_MODAL_BODY}
          </P>
          {errorLine}
          {field}
          <Flex gap="s" mt="s">
            <Button
              type="button"
              disabled={saveDisabled}
              onClick={() => onSave(draft)}
            >
              {EXCEPTION_REASON_SAVE}
            </Button>
            {onCancel ? (
              <Button variant="ghost" type="button" onClick={onCancel}>
                Cancel
              </Button>
            ) : null}
          </Flex>
        </>
      );
    default: {
      const unexpected: never = layout;
      return unexpected;
    }
  }
};

export default ExceptionReasonForm;
